/* DSCPLN — proof ticker marquee. Pause on hover, respect prefers-reduced-motion. */
(function () {
  function init(el) {
    if (el.dataset.dscplnMarqueeInit === "1") return;
    el.dataset.dscplnMarqueeInit = "1";

    var track = el.querySelector("[data-marquee-track]");
    if (!track) return;

    var inner = track.innerHTML;
    var minWidth = el.offsetWidth * 2;
    while (track.scrollWidth < minWidth) {
      track.insertAdjacentHTML("beforeend", inner);
    }

    var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduceMotion) return;

    var speed = parseFloat(el.dataset.marqueeSpeed || "60");
    var offset = 0;
    var last = performance.now();
    var paused = false;

    el.addEventListener("mouseenter", function () { paused = true; });
    el.addEventListener("mouseleave", function () { paused = false; });

    function tick(now) {
      var dt = (now - last) / 1000;
      last = now;
      if (!paused) {
        offset -= speed * dt;
        var cycle = track.scrollWidth / 2;
        if (Math.abs(offset) >= cycle) offset += cycle;
        track.style.transform = "translateX(" + offset + "px)";
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function boot() {
    document.querySelectorAll("[data-dscpln-marquee]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", boot);
})();
